import { useRepositoryQuery } from '@mews-commander/data-access';

export const useShiftData = (cashierId?: string, shiftId?: string) => {
    const getShift = useRepositoryQuery('cashiers', 'getShift', { shiftId: shiftId || '' }, { enabled: !!shiftId });
    const getCurrentShift = useRepositoryQuery(
        'cashiers',
        'getCurrentShift',
        { cashierId: cashierId || '' },
        { enabled: !!cashierId }
    );
    return shiftId ? getShift : getCurrentShift;
};
